import { Track } from "./tracks";
import { Vehicle } from "./vehicle";

export class CarTrackSettings {
  manufacturer: string;
  vehicleId: number;
  performancePoints: number;
  weight: number;
  tireSize: number;
  trackType: number = 0;
  trackName: string;
  track: Track;
  rearTires: number = 0;
  frontTires: number = 0;
  vehicle: Vehicle;
}
